/**
 * @module Passage
 */
'use strict';

var Route = require('./lib/route');


module.exports = Route;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/route-parser/index.js
 ** module id = 340
 ** module chunks = 1
 **/